import { ApiKey, ApiKeyBE } from '@/types/organization';

export const mapApiKeyBEsToDTO = (
  apiKeyBE: ApiKeyBE
): ApiKey => {
  return {
    id: apiKeyBE.id.toString(),
    name: apiKeyBE.name,
    abilities: apiKeyBE.abilities,
    expiresAt: apiKeyBE.expires_at,
    token: apiKeyBE.token,
  };
};

export const mapApiKeysBEsToDTO = (
  apiKeyBEArray: ApiKeyBE[]
): ApiKey[] => {
  return apiKeyBEArray.map((apiKeyBE) => {
    return mapApiKeyBEsToDTO(apiKeyBE);
  });
};

export const mapApiKeyDTOToBEForCreate = (
  apiKey: Partial<ApiKey>
): Partial<ApiKeyBE> => {
  return {
    name: apiKey.name,
    abilities: apiKey.abilities,
    expires_at: apiKey.expiresAt,
  };
};

export const mapApiKeyDTOToBEForUpdate = (
  apiKey: Partial<ApiKey>
): Partial<ApiKeyBE> => {
  return {
    id: apiKey.id ? +apiKey.id : 0,
    name: apiKey.name,
    expires_at: apiKey.expiresAt,
  };
};
